import React, { useState } from 'react';
import DataTableCrudTest from './DataTableCrudTest';
import DataTreeCrudTest from './DataTreeCrudTest';
import CardGridTest from './CardGridTest';
import SidebarDocumentTest from './SidebarDocumentTest';
import LayoutVariationsDemo from './LayoutVariationsDemo';
import ComponentDemo from './ComponentDemo';
import CSSReferenceModal from './CSSReferenceModal';
import TestHeader from './TestHeader';
import TestMenu from './TestMenu';
import TestFooter from './TestFooter';
import TestModuleHeader from './TestModuleHeader';
import TestTabs from './TestTabs';
import TestRightSidebar from './TestRightSidebar';
// import '../../styles/layout-slices.css.TEST_PAGES_ONLY';

interface LayoutTestPageProps {
  onBackToApp: () => void;
}

const LayoutTestPage: React.FC<LayoutTestPageProps> = ({ onBackToApp }) => {
  const [activeTab, setActiveTab] = useState('tab1');
  const [showCSSReference, setShowCSSReference] = useState(false);

  return (
    <div className="full-area">
      {/* Header Row */}
      <div className="header-row is-sticky">
        <TestHeader
          title="Layout Test Page"
          onBackToApp={onBackToApp}
          onShowReference={() => setShowCSSReference(true)}
        />
      </div>

      {/* Body Grid: Menu Area + Page Area */}
      <div className="body-grid">

        {/* Left Menu Area */}
        <div className="menu-area">
          <TestMenu />
        </div>

        {/* Main Page Area */}
        <div className="page-area">

          {/* Module Row - Level 3 */}
          <div className="module-row">
            <TestModuleHeader
              title={
                activeTab === 'tab1' ? '📊 Data Table CRUD Pattern' :
                  activeTab === 'tab2' ? '🌲 Hierarchical Tree CRUD Pattern' :
                    activeTab === 'tab3' ? '🎯 Card Grid Layout Pattern' :
                      activeTab === 'tab4' ? '📄 Sidebar + Document Pattern' :
                        activeTab === 'tab5' ? '🏗️ Layout System Variations Demo' :
                          activeTab === 'tab6' ? '🧩 Component Demo Showcase' :
                            'Layout Test Module'
              }
              onSettingsClick={() => console.log('Settings clicked')}
            />
          </div>

          {/* Module Area: Main Content (80%) + Right Widgets (20%) - Level 3 */}
          <div className="module-area">

            {/* Module Content Area (Left ~80%) - Level 4 */}
            <div className="module-content-area">

              {/* Tabs Row - Level 5 */}
              <div className="tabs-row">
                <TestTabs
                  activeTab={activeTab}
                  onTabChange={setActiveTab}
                />
              </div>

              {/* Tab Content Area - Level 5 */}
              <div className="tab-content-area">
                {activeTab === 'tab1' && <DataTableCrudTest />}
                {activeTab === 'tab2' && <DataTreeCrudTest />}
                {activeTab === 'tab3' && <CardGridTest />}
                {activeTab === 'tab4' && <SidebarDocumentTest />}
                {activeTab === 'tab5' && <LayoutVariationsDemo />}
                {activeTab === 'tab6' && <ComponentDemo />}
              </div>
            </div>

            {/* Module Widget Area (~15%) */}
            <div className="module-widget-area">
              <TestRightSidebar activeTab={activeTab} />
            </div>
          </div>

        </div>
      </div>

      {/* Footer Row */}
      <div className="footer-row">
        <TestFooter appName="AnyGRC" version="v2.0" />
      </div>

      {/* CSS Reference Modal */}
      {showCSSReference && (
        <CSSReferenceModal onClose={() => setShowCSSReference(false)} />
      )}
    </div>
  );
};

export default LayoutTestPage;